<template>
  <div class="modalWrap">
    <div class="modal">
      <slot></slot>

      <button
        type="button"
        class="close"
        @click="commit('unFixBody'), $emit('close-modal')"
      >
        <img src="@/assets/images/icon/close-main.svg" alt="" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted } from '@vue/runtime-core'
import { useStore } from 'vuex'
export default {
  name: 'ModalBase',
  setup() {
    const { commit } = useStore()
    onMounted(() => commit('fixBody'))
    return {
      commit
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.modalWrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  z-index: 999;
  padding: 60px 0 40px;

  @include mixins.media() {
    background-color: rgba(255, 255, 255, 0.9);
    padding: 95px 0 80px;
  }
}

.modal {
  padding-left: 16px;
  padding-right: 16px;
  @include mixins.media() {
    width: 712px;
    padding: 40px;
    background-color: #fff;
    border: 1px solid var.$color-main;
    border-radius: 15px;
    position: relative;
    max-height: 100%;
  }
}

.close {
  position: absolute;
  top: 17px;
  right: 17px;

  @include mixins.media() {
    top: -35px;
    right: 0;
  }

  > img {
    width: 20px;
    height: 20px;
  }
}
</style>
